import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ReflexesLinguistiques() {
  return <Navigate to="/speaking-lab/scribble" replace />;
}
